module.exports = __webpack_public_path__ + "img/share2.40cf3e24.jpg";